import {
    AwesomeTableComponent,
    DialogManager,
    HeaderTable,
    IColumnsProps,
    Notifications,
    Progress,
    TimeUtils,
    ViewLabelStatus,
} from "d-react-components";
import { debounce } from "lodash";
import React, { useRef } from "react";
import { generatePath, useHistory } from "react-router-dom";

import CriteriaAPI from "../../../api/criteria/CriteriaAPI";
import AppLink from "../../../common/AppLink";
import TableAction from "../../../common/TableActions";
import { CRITERIA_STATUSES } from "../../../constant/criteria";
import { ICriteria } from "../../../interfaces/criteria";

import Messages from "../../../languages/Messages";
import Path from "../../Path";

const CriteriaTable = () => {
    const tableRef = useRef<any>(null);
    const searchRef = useRef<string>("");
    const history = useHistory();
    const columns: IColumnsProps = [
        {
            title: Messages.title,
            dataIndex: "name",
            render: (name, item) => (
                <AppLink
                    to={generatePath(Path.CRITERIA_DETAIL, {
                        criteriaId: item.id,
                    })}
                >
                    {name}
                </AppLink>
            ),
        },

        {
            title: Messages.type,
            dataIndex: "type",
        },
        {
            title: Messages.valueQty,
            dataIndex: "valuesQty",
        },
        {
            title: Messages.status,
            dataIndex: "status",
            render: (status) => (
                <ViewLabelStatus
                    status={status}
                    listStatus={CRITERIA_STATUSES}
                    getLabel={(item) => (Messages as any)[item.label]}
                />
            ),
        },

        {
            title: Messages.createdAt,
            dataIndex: "createdAt",
            render: TimeUtils.toDateTime,
        },
        {
            title: Messages.updateAt,
            dataIndex: "updatedAt",
            render: TimeUtils.toDateTime,
        },
        {
            title: Messages.action,
            dataIndex: "",
            align: "center",
            render: (criteria: ICriteria) => {
                return (
                    <TableAction
                        onClick={(actionId: string) =>
                            onClickTableAction(actionId, criteria)
                        }
                    />
                );
            },
        },
    ];

    const source = (pagingData: any) => {
        return CriteriaAPI.list(searchRef.current, pagingData);
    };

    const onClickTableAction = (actionId: string, criteria: ICriteria) => {
        switch (actionId) {
            default:
                history.push(
                    generatePath(Path.CRITERIA_DETAIL, {
                        criteriaId: criteria.id,
                    })
                );
        }
    };

    const onClickAddNew = () => {
        history.push(Path.CRITERIA_CREATE);
    };

    const onChangeSearch = debounce((text) => {
        searchRef.current = text;
        tableRef.current.refresh();
    }, 500);

    return (
        <div className="p-4">
            <HeaderTable
                onClickNew={onClickAddNew}
                label={Messages.criteria}
                // onClickFilter={() => {}}
                onChangeText={(event: any) =>
                    onChangeSearch(event.target.value)
                }
                className="mb-3"
            />
            <AwesomeTableComponent
                ref={(ref) => {
                    tableRef.current = ref;
                }}
                source={source}
                transformer={(res) => {
                    return res?.data?.data?.criteria ?? [];
                }}
                columns={columns}
                showSelectColumn
                baseColumnProps={{ width: 100 }}
            />
        </div>
    );
};

export default CriteriaTable;
